import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { RegionProvider } from "@/context/RegionContext";
import { AuroraBackground } from "@/components/AuroraBackground";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import KeywordBoard from "@/pages/KeywordBoard";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import HowItWorks from "@/pages/HowItWorks";
import Rules from "@/pages/Rules";
import Terms from "@/pages/Terms";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Contact from "@/pages/Contact";
import MyHome from "@/pages/MyHome";
import MyWallet from "@/pages/MyWallet";
import MyWalletSuccess from "@/pages/MyWalletSuccess";
import GlobalWallet from "@/pages/GlobalWallet";
import CheckEmail from "@/pages/CheckEmail";
import VerifyEmail from "@/pages/VerifyEmail";
import MyKeywordBoard from "@/pages/MyKeywordBoard";

function hasSessionId(location) {
  // Stripe redirects to /my/wallet/success?session_id=... — that must NOT be treated
  // as an OAuth callback; only the Google login flow uses session_id elsewhere.
  if (location.pathname === "/my/wallet/success") return false;
  return (
    (location.hash && location.hash.includes("session_id=")) ||
    (location.search && location.search.includes("session_id="))
  );
}

function AppRouter() {
  const location = useLocation();
  if (hasSessionId(location)) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/k/:slug" element={<KeywordBoard />} />
        <Route path="/wallet" element={<GlobalWallet />} />
        <Route path="/wallet/success" element={<MyWalletSuccess region="global" />} />
        <Route path="/check-email" element={<CheckEmail />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/my" element={<MyHome />} />
        <Route path="/my/wallet" element={<MyWallet />} />
        <Route path="/my/wallet/success" element={<MyWalletSuccess />} />
        <Route path="/my/k/:slug" element={<MyKeywordBoard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <AuroraBackground />
      <BrowserRouter>
        <AuthProvider>
          <RegionProvider>
            <AppRouter />
            <Toaster position="top-right" theme="dark" richColors />
          </RegionProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
